module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "calendar-container border-bottom"
  }, [_c('div', {
    staticClass: "swiper-container padding-top",
    attrs: {
      "id": "calendar-swiper-container"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.orderedList), function(item) {
    return _c('dsCalendarItem', {
      attrs: {
        "item": item,
        "language": _vm.language
      }
    })
  }))]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-nav"
  }, [_c('span', {
    staticClass: "button-prev secondary-color"
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "button-next secondary-color"
  }, [_vm._v(">")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e09bcd7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsCalendar.vue
// module id = 222
// module chunks = 2